// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1EZEk","content":"ManualTimeModal_content__1tlLO"};